import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { MatStepper } from "@angular/material/stepper";
import moment from "moment";
import { AppService } from "src/app/core/services/app.service";
import { FocusdataService } from "src/app/core/services/focusdata.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { UserService } from "src/app/core/services/user.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { EmployeeMessageItem } from "src/app/shared/models/EmployeeMessage.item";
import { EmployeeMsgNotifyType } from "src/app/shared/models/enums/employee-notification-type.enum";
import { EmployeeRecord } from "src/app/shared/models/focusDataModels/EmployeeRecord";

@Component({
	selector: "app-employee-message-new-record",
	templateUrl: "./employee-message-new-record.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class EmployeeMessageNewRecordComponent implements OnInit {
	@ViewChild("msgStepper") msgStepper: MatStepper;
	@Input() employeeList: EmployeeRecord[];
	@Output() clearEmitter = new EventEmitter<boolean>();
	@Output() sentMessagePayload = new EventEmitter<EmployeeMessageItem[]>();

	employeeListAvailable: EmployeeRecord[];
	employeeListSelected: EmployeeRecord[];

	employeeRecordsSelected: EmployeeRecord[];

	pendingMessageList: EmployeeMessageItem[];
	premessage: EmployeeMessageItem;
	premessageEmployeeNickNames: string[];

	messageTypeForm: UntypedFormGroup;
	messageSelectedEmployeesForm: UntypedFormGroup;
	messagePropertiesForm: UntypedFormGroup;

	notificationMethods = [
		{
			label: "Email",
			value: 1,
			disabled: true,
		},
		{
			label: "SMS",
			value: 2,
			disabled: true,
		},
		{
			label: "Store POS Message",
			value: 3,
		},
		{
			label: "CommandCenter Message",
			value: 4,
			disabled: true,
		},
		{
			label: "FocusOne Push Notification",
			value: 5,
			disabled: true,
		},
	];

	visible: boolean = true;

	constructor(
		public app: AppService,
		private focuslink: FocuslinkService,
		private focusdata: FocusdataService,
		private formbuilder: UntypedFormBuilder,
		public venueService: OOVenueService,
		public userService: UserService
	) {}

	ngOnInit(): void {
		const smsNotifyMethod = this.notificationMethods.find((i) => i.value === 2);
		console.log(this.venueService.subscriptionVenue.value.integrations);
		if (this.venueService.subscriptionVenue.value.integrations?.some((i) => i === "order-ready-text")) {
			smsNotifyMethod.disabled = false;
		}
		this.messagePropertiesForm = this.formbuilder.group({
			subject: ["", Validators.required],
			body: ["", Validators.required],
			sendDateTime: [""],
		});
		this.messageSelectedEmployeesForm = this.formbuilder.group({
			selectedEmployees: ["", Validators.required],
		});
		this.messageTypeForm = this.formbuilder.group({
			type: ["", Validators.required],
		});

		this.messageTypeForm.statusChanges.subscribe((status) => {
			if (status === "VALID") {
				this.filterEmployeeListBasedOnNotifyType(+this.messageTypeForm.value.type);
				this.msgStepper.next();
			}
		});

		this.employeeRecordsSelected = [];
	}

	composeMessage() {
		this.employeeRecordsSelected = this.messageSelectedEmployeesForm.value.selectedEmployees;
		this.premessageEmployeeNickNames = this.messageSelectedEmployeesForm.value.selectedEmployees.map((i) => i.NickName);
		this.premessage = new EmployeeMessageItem({
			pk: `EMPMSG_${this.venueService.subscriptionVenue.value.key}`,
			authorUserKey: this.userService.userSubscription.value.key,
			subject: this.messagePropertiesForm.value.subject,
			body: this.messagePropertiesForm.value.body,
			notificationType: +this.messageTypeForm.value.type,
		});
	}

	createMessageAndSend() {
		this.pendingMessageList = [];
		const msgCreateDateTime = moment();
		this.employeeRecordsSelected.forEach((employee) => {
			const msg = new EmployeeMessageItem({
				pk: this.premessage.pk,
				sk: `${employee.ID}_${msgCreateDateTime.valueOf()}`,
				authorUserKey: this.premessage.authorUserKey,
				subject: this.premessage.subject,
				body: this.premessage.body,
				created: msgCreateDateTime.format(),
				modified: msgCreateDateTime.format(),
				notificationType: this.premessage.notificationType,
				notificationAddress: this.employeeNotificationAddressBuild(this.premessage.notificationType, employee),
			});

			this.pendingMessageList.push(msg);
		});

		this.sendMessages(this.pendingMessageList);
		this.sentMessagePayload.emit(this.pendingMessageList);
		this.clearEmitter.emit(true);
		this.app.msgSvc.add({ severity: "success", detail: `${this.pendingMessageList.length} messages sent.` });
	}

	employeeListSelect() {
		this.employeeRecordsSelected = this.messageSelectedEmployeesForm.value.selectedEmployees;
	}

	employeeNotificationAddressBuild(type: number, employeeRecord: EmployeeRecord) {
		switch (type) {
			case EmployeeMsgNotifyType.EMAIL: {
				return employeeRecord.Email;
				break;
			}
			case EmployeeMsgNotifyType.ONLINEONLY: {
				//not supported yet
				break;
			}
			case EmployeeMsgNotifyType.PUSHNOTIFICATION: {
				//no supported yet
				break;
			}
			case EmployeeMsgNotifyType.SMS: {
				return this.app.references.phoneToformatE164(employeeRecord.Phone1);
				break;
			}
			case EmployeeMsgNotifyType.STOREMESSAGE: {
				return employeeRecord.NickName;
				break;
			}
			default: {
				return employeeRecord.NickName;
				break;
			}
		}
	}

	filterEmployeeListBasedOnNotifyType(method: number) {
		this.employeeListAvailable = [];
		switch (method) {
			case EmployeeMsgNotifyType.EMAIL: {
				this.employeeListAvailable = this.employeeList.filter((i) => {
					if (i.Email && i.Email.includes("@")) {
						return i;
					}
				});
				break;
			}
			case EmployeeMsgNotifyType.ONLINEONLY: {
				//not supported yet
				break;
			}
			case EmployeeMsgNotifyType.PUSHNOTIFICATION: {
				//no supported yet
				break;
			}
			case EmployeeMsgNotifyType.SMS: {
				this.employeeListAvailable = this.employeeList.filter((i) => i.Phone1);
				break;
			}
			case EmployeeMsgNotifyType.STOREMESSAGE: {
				this.employeeListAvailable = this.employeeList.filter((i) => i.IsActive);
				break;
			}
			default: {
				this.employeeListAvailable = this.employeeList.filter((i) => i.IsActive);
				break;
			}
		}
	}

	async sendMessages(messagePayload: EmployeeMessageItem[]) {
		this.focuslink.employeeMessagePost(this.venueService.subscriptionVenue.value.key, messagePayload);
	}
}
